/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import object, { string, shape, array } from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { compose } from 'recompose';
import { getPresentationFamily } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getSSRDeviceType } from '../../../../state/ducks/App/App-Selectors';

const styles = (theme) => ({   // eslint-disable-line arrow-parens
    seoBlock: {
        boxSizing: 'border-box',
        maxWidth: '980px',
        margin: '40px auto',
        fontSize: '.8em',
        color: theme.palette.colorPrimary,
        '& h1, h2 ': {
            fontSize: '1.4em',
            textAlign: 'center',
            fontWeight: '400',
        },
    },

    column: {
        padding: '0 20px',
        '& img': {
            display: 'block',
            width: '100%',
            minHeight: '30px',
            margin: '0 auto',
        },
        '& a': {
            color: `${theme.palette.colorPrimary}99`,
        },
    },
    seoWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0 10px',
        whiteSpace: 'nowrap',
        '&:focus': {
            outline: 'none',
            borderBottom: `1px solid ${theme.palette.colorNeutral30}`,
            borderTop: `1px solid ${theme.palette.colorNeutral30}`,
        },
        cursor: 'pointer',
        [theme.breakpoints.down(680)]: {
            display: 'inline-block',
            width: '100%',
        },
    },
    seoHeading: {
        '& h1': {
            display: 'block',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        },
        [theme.breakpoints.down(680)]: {
            width: '58%',
            float: 'left',
        },
    },
    seoExpand: {
        height: 'auto',
        overflowY: 'hidden',
        minHeight: '50px',
        transition: 'height 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    },
    seoToggle: {
        display: 'block',
        verticalAlign: 'middle',
        marginBlockStart: '0.67em',
        marginBlockEnd: '0.67em',
        marginInlineStart: 0,
        marginInlineEnd: 0,
    },
    seoHide: {
        height: '0px',
        overflowY: 'hidden',
    },
});

const SeoBlock = ({
    classes, data, presentation_family, ssrDeviceType,
}) => {
    const {
        flourish_image = '',
        markdown = '',
        title = '',
    } = data;

    // Use for to check the deviceType
    const checkDeviceType = ssrDeviceType === 'desktop';

    // Use for seo expand only food brand
    const [expanded, setExpanded] = useState(checkDeviceType);
    return (
        <>
            {presentation_family === 'food' && markdown.length
                ? (
                    <>
                        <Grid className={classes.seoBlock} container>
                            <div
                                className={classes.root}
                            >
                                <div>
                                    <div className={classes.seoWrapper} onClick={() => { setExpanded(!expanded); }} onKeyDown={() => { }} role="button" tabIndex={-1}>
                                        <div className={classes.seoHeading}>{title}</div>
                                        <div className={classes.seoToggle}>{expanded ? '- Read Less' : '+ Read More'}</div>
                                    </div>
                                    <div className={expanded ? classes.seoExpand : classes.seoHide} seocolumns="">
                                        {
                                            markdown.map((k, i) => {
                                                const zeroBaseMarkdownLength = markdown.length - 1;
                                                const flourishImage = zeroBaseMarkdownLength === i && flourish_image ? <img src={flourish_image.url} alt={flourish_image.description} /> : '';
                                                return <Grid item xs={12} sm className={classes.column}><ReactMarkdown escapeHtml={false} source={k} />{flourishImage}</Grid>;
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </>
                )
                : (
                    <Grid className={classes.seoBlock} container>
                        {
                            markdown.map((k, i) => {
                                const zeroBaseMarkdownLength = markdown.length - 1;
                                const flourishImage = zeroBaseMarkdownLength === i && flourish_image ? <img src={flourish_image.url} alt={flourish_image.description} /> : '';
                                return <Grid item xs={12} sm className={classes.column}><ReactMarkdown escapeHtml={false} source={k} />{flourishImage}</Grid>;
                            })
                        }
                    </Grid>
                )}
        </>
    );
};

SeoBlock.propTypes = {
    data: shape({
        seo_copy: shape({
            flourish_image: shape({
                title: string,
                url: string,
            }).isRequired,
            markdown: array,
            title: string,
        }).isRequired,
    }).isRequired,
    classes: object.isRequired,
    presentation_family: string.isRequired,
    ssrDeviceType: string.isRequired,
};

const mapStateToProps = (state) => ({
    presentation_family: getPresentationFamily(state),
    ssrDeviceType: getSSRDeviceType(state),

});
const enhance = compose(
    withStyles(styles),
    connect(mapStateToProps),
);

export default enhance(SeoBlock);
